import { makeStyles } from '@material-ui/core/styles';
import { getStyle, mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { styleBreakDesktop, styleBreakMobile, styleBreakSmallMobile } from '../components/utilities/layouts/Globals';
import { COLOR_WHITE } from '../components/utilities/Material';

export const SetupAccountStep1WelcomeStyle = makeStyles(theme => {
    const defaultstyles = {
        logo: {
            height: '37px',
            width: '67px',
            marginTop: theme.spacing(2),
            [styleBreakDesktop(theme)]: {
                marginTop: theme.spacing(5),
            },
            [styleBreakSmallMobile(theme)]: {
                height: '24px',
            },
        },
        button: {
            width: '100%',
            marginTop: theme.spacing(10),
            [styleBreakSmallMobile(theme)]: {
                marginTop: theme.spacing(4),
            },
            [styleBreakDesktop(theme)]: {
                width: theme.spacing(35),
            },
        },
        title: {
            [styleBreakMobile(theme)]: {
                marginTop: theme.spacing(10),
            },
            [styleBreakSmallMobile(theme)]: {
                marginTop: theme.spacing(4),
            },
            marginBottom: theme.spacing(2),
            lineHeight: 1.25,
            letterSpacing: '0.3px',
        },
        hospitalLogo: {
            height: theme.spacing(25),
            width: theme.spacing(23),
            display: 'block',
            position: 'fixed',
            left: theme.spacing(-2),
            bottom: theme.spacing(-2),
            [styleBreakDesktop(theme)]: {
                height: theme.spacing(40),
                width: theme.spacing(37),
            },
            [styleBreakSmallMobile(theme)]: {
                zIndex: '-9999',
                height: '185px',
            },
        },
        content: {
            [styleBreakDesktop(theme)]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 'auto',
                marginBottom: 'auto',
            },
        },
        body: {
            [styleBreakDesktop(theme)]: {
                maxWidth: '378px',
                textAlign: 'center',
            },
        },
        pageContainer: {
            [styleBreakDesktop(theme)]: {
                height: '100vh',
            },
        },
    };

    // overrides to the default
    /* Add watchman specific styles */
    const watchmanstyles = mergeStyles(cloneDeep(defaultstyles), {
        logo: {
            height: '43px',
            width: '201px',
            [styleBreakDesktop(theme)]: {
                marginTop: 0,
            },
            [styleBreakSmallMobile(theme)]: {
                height: '43px',
            },
        },
        h2: {
            fontSize: theme.spacing(5),
            margin: 0,
            [styleBreakMobile(theme)]: {
                fontSize: theme.spacing(4) - 2
            },
        },
        welcomeHeader: {
            marginRight: theme.spacing(1) + 2,

        }
    });

    /* Add ned specific styles */
    // overrides to the default
    const nedstyles = mergeStyles(cloneDeep(defaultstyles), {
        logo: {
        },
    });

    return getStyle({
        ned: nedstyles,
        watchman: watchmanstyles,
    });
});


export const stylesOverrideForFullScreenComponent = theme => {

    return {
        // for full page components, change background-color of body
        // to white
        '@global':{
            body:{
                backgroundColor: COLOR_WHITE,
            }
        },
        body: {
            maxWidth: theme.spacing(55.5),
            marginBottom: 0,
        },
        bodyText: {
            maxWidth: theme.spacing(47.25),
            [styleBreakMobile(theme)]: {
                maxWidth: theme.spacing(37.25),
                margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`
            },
        },
        fullscreenButtonPageHorizontalPaddingOverride: {
            maxWidth: theme.spacing(115),
            [styleBreakDesktop(theme)]: {
                minWidth: theme.spacing(115),
            },
        },
        icon: {
            width: theme.spacing(50),
            height: theme.spacing(50),
            [styleBreakMobile(theme)]: {
                width: theme.spacing(32.5),
                height: theme.spacing(32.5),
                marginLeft: -theme.spacing(2),
            },
            [styleBreakSmallMobile(theme)]: {
                width: theme.spacing(27.5),
                height: theme.spacing(27.5),
            },
        }
    }
};